"use client";
/*
 * Documentation:
 * Dialog — https://app.subframe.com/library?component=Dialog_ca59db17-43fb-4247-8094-3c55162e902d
 * Button — https://app.subframe.com/library?component=Button_3b777358-b86b-40af-9327-891efc6826fe
 */

import React from "react";
import * as SubframeCore from "@subframe/core";

interface ContentProps
  extends React.ComponentProps<typeof SubframeCore.Dialog.Content> {
  children?: React.ReactNode;
  className?: string;
}

const Content = React.forwardRef<HTMLElement, ContentProps>(function Content(
  { children, className, ...otherProps }: ContentProps,
  ref
) {
  return (
    <SubframeCore.Dialog.Content asChild={true} {...otherProps}>
      <div
        className={SubframeCore.twClassNames(
          "flex min-w-[320px] flex-col items-start gap-2 rounded border border-solid border-neutral-border bg-default-background shadow",
          className
        )}
        ref={ref as any}
      >
        {children}
      </div>
    </SubframeCore.Dialog.Content>
  );
});

interface DialogRootProps
  extends React.ComponentProps<typeof SubframeCore.Dialog.Root> {
  children?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}

const DialogRoot = React.forwardRef<HTMLElement, DialogRootProps>(
  function DialogRoot(
    { children, className, ...otherProps }: DialogRootProps,
    ref
  ) {
    return (
      <SubframeCore.Dialog.Root asChild={true} {...otherProps}>
        <div
          className={SubframeCore.twClassNames(
            "flex h-full w-full flex-col items-center justify-center gap-2 bg-[#00000099]",
            className
          )}
          ref={ref as any}
        >
          {children}
        </div>
      </SubframeCore.Dialog.Root>
    );
  }
);

export const Dialog = Object.assign(DialogRoot, {
  Content,
});
